import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const WebhookConfigInput = () => {
  const { configId = '' } = useParams();
  const decodedId = configId ? atob(configId) : configId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'webhookConfig';

  useEffect(() => {
    if (configId) {
      setIsEditing(true);
      fetchConfigDetails();
    }
  }, [configId]);

  const fetchConfigDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.webhookConfig}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching webhook config details:', error);
    }
  };

  const configFields = [
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'destination_url', label: 'Destination URL', type: 'text', required: true },
    { name: 'api_key', label: 'API Key', type: 'text', required: true },
    { name: 'is_active', label: 'Is Active', type: 'checkbox' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Webhook Config' : 'Create Webhook Config'}</h1>
      <FormComponent fields={configFields} initialFormData={formData} route={route} cancelPath="/customer/webhook-config/list" />
    </div>
  );
};

export default WebhookConfigInput;
